import styled, { css } from 'styled-components'
import SelectMultipleStyle from 'react-select'
export const Container = styled.div`
    .select-operator {
        width: 100%;
        margin-top: .3rem;
        &_container{
          > div {
            display: flex;
            flex-wrap: wrap;
            padding: -5px;
            > div{
                background-color: ${({theme}) => theme.secondary};
                color: ${({theme}) => theme.bg};
                border-radius: 5px;
                margin: 5px;
            }
          }
        }
    }
`

export const SelectMultiple = styled(SelectMultipleStyle).attrs((props) => ({
	...props,
	theme: (theme) => ({
		...theme,
		colors: {
			...theme.colors,
			neutral0: "#FFF",
			primary: "#7D3CE8",
			primary25: "rgba(125,60,232,.25)",
			primary50: "rgba(125,60,232,.5)",
			primary75: "rgba(125,60,232,.75)"
		}
	}),
	styles: {
		control: (data) => ({...data, width: 220}),
		menuPortal: (base) => ({...base, zIndex: 9999, backgroundColor: '#FFF'})
	},
	placeholder: props.placeholder ?? "Digite ou selecione",
	maxMenuHeight: 220,
	menuPlacement: "auto",
	menuPortalTarget: document.getElementById('root'),
}))`
    && {
        ${({error}) => error && css`>div {border-color: #F44336;}`}
    }
`